<div class="container-fluid mx-lg-1 mx-0 ">
  <div class="row  mb-0 ">
    <div class="col-12">
      <div class="d-flex">
        <div class="mr-auto px-0 mt-2 w-100">
          <div class="form-group has-search  mr-3">
            <span class="fa fa-search form-control-feedback"></span>
            <form [formGroup]="searchForm">
              <input formControlName="search" type="text" class="form-control"
                placeholder="{{ 'COMMON.SEARCH_HERE' | translate }}">
            </form>
            <button type="button" class="btn bg-transparent searchclear" *ngIf="searchForm.value.search"
              (click)="searchForm.setValue({search: ''})">
              <i class="fa fa-times"></i>
            </button>
          </div>
        </div>
        <div class="px-0 mt-2">
          <div class=" d-flex-center mr-3">
            <ng-template #popTemplate>
              <div>
                <button [ngClass]="{'btn-purple': latestSort}" (click)="sortSearch('sortByNew')" type="button"
                  class="btn sort-btn btn-dark">
                  {{'COMMON.LETEST' | translate}}
                </button>
              </div>
              <div class="mt-2">
                <button [ngClass]="{'btn-purple': nameSort}" (click)="sortSearch('sortByCate')" type="button"
                  class="btn sort-btn btn-dark">
                  {{'COMMON.NAME' | translate}}

                </button>
              </div>
            </ng-template>
            <button type="button" triggers="click" outsideClick="true"  class="btn text-header-backClr header-text border-dark text-white"
              [popover]="popTemplate"  placement="left" >
              <i popover-trigger="focus" class="fas fa-sort-alt"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row search-contain mx-1" [hidden]="searchForm.value.search">
    <div class="col-12">
      <div class="row">
        <!-- <div class="col-12 text-left py-2" *ngIf="recentSearches.length>0">
          <div class="d-flex space-between" >
          <h5 class="d-flex">{{'COMMON.RECENT_SEARCH' | translate}} </h5>
          <p ><i class="fa fa-times" (click)="removeSearchKeys()"></i></p >
          </div>
          <div class="d-flex search-list">
            <div *ngFor="let item of recentSearches; let i = index">
              <span class="badge badge-secondary p-2 mx-2 cursor-pointer">
                <span (click)="searchByRecentKey(item)">{{item}} </span>
                <i (click)="removeSearchKey(i)" class="fa fa-times"></i>
              </span>
            </div>
          </div>
        </div> -->
      </div>
      <div class="row mt-3" *ngIf="!isLiveLoading && !isSorting">

        <div class="col-12 d-flex">
          <h5 class="mr-auto">{{'NAV.NAV3' | translate}}</h5>
          <a class="mr-2 text-white" routerLink="/livetv">{{'COMMON.VIEW_ALL' | translate}}  <i class="fas fa-angle-right"></i></a>
        </div>
        <div class="col-12 ml-3 mr-4 pr-5">
          <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfigLive">

            <!-- (click)="updateChannelEpg(channel.stream_id,channel.name)" -->
            <div ngxSlickItem class="slide" *ngFor="let channel of liveStream | slice:0:200; index as i">
              <div class="pr-2">
                <div class="mr-3 over1 d-flex" (mousedown)="onMouseDown($event)"
     (mouseup)="onMouseUpLivetv($event, channel)"
     (touchstart)="onMouseDown($event)"
     (touchend)="onMouseUpLivetv($event, channel)">
                  <div class="px-1 py-2">
                    <img [src]="channel.stream_icon"   class="mb-0 liveimg" loading=lazy>
                  </div>
                  <div class="p-2 py-3 search-title cursor-pointer">
                    {{channel.name}}
                  </div>
                </div>
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
        <div class="loading"  style="height: 4rem;display: flex;justify-content: center;align-items: center;" *ngIf="!liveStream">Loading ....</div>
      </div>
      <div class="row mt-3 " *ngIf="!isSorting">
        <div class="col-12 d-flex">
          <h5 class="mr-auto">{{'NAV.NAV4' | translate}}</h5>
          <a class="mr-2 text-white" routerLink="/movies">{{'COMMON.VIEW_ALL' | translate}}  <i class="fas fa-angle-right"></i></a>
        </div>
        <div class="col-12 mx-3 mr-4 pr-5">
          <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let select of movieShowList | slice:0:500; let i=index;" class="slide">
              <div class="imageContainer-search  position-relative"  (mousedown)="onMouseDown($event)"
  (mouseup)="onMouseUp($event, select)"
  (touchstart)="onMouseDown($event)"
  (touchend)="onMouseUp($event, select)">
                <img class=" search-imgseries  cursor-pointer" [src]="select.stream_icon" alt="{{select.name}}" loading=lazy>
                <!-- <p class="search-titles  p-0" title="{{select.name}}">{{select.name}}</p> -->
              </div>
            </div>
            <div class="slide d-flex justify-content-center" *ngIf="loadMovies"  (click)="loadMovie()">
              <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadMovie()" *ngIf="!isLoading ">
                 <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                  <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                  <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                </svg>
              </div>
              <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status">
            </div>
            </div>
          </ngx-slick-carousel>
          
        </div>
      </div>
      <div class="row mt-3 mb-3" *ngIf=" !isSorting">
        <div class="col-12 d-flex">
          <h5 class="mr-auto">{{'NAV.NAV5' | translate}}</h5>
          <a class="mr-2 text-white" routerLink="/series">{{'COMMON.VIEW_ALL' | translate}} <i class="fas fa-angle-right"></i></a>
        </div>
        <div class="col-12 mx-3 mr-4 pr-5">
          <ngx-slick-carousel class="carousel custom-slider" #slickModal="slick-carousel" [config]="slideConfig">
            <div ngxSlickItem *ngFor="let select of seriesShowList | slice:0:500; let i=index;" class="slide">
              <div class="imageContainer-search">
                <img class=" search-imgseries cursor-pointer" [src]="select.cover" alt="{{select.name}}"
                  loading=lazy (mousedown)="onMouseDown($event)"
     (mouseup)="onMouseUpSeries($event, select)"
     (touchstart)="onMouseDown($event)"
     (touchend)="onMouseUpSeries($event, select)">
                <!-- <p class="search-title text-left" title="{{select.name}}">{{select.name}}</p> -->
              </div>
            </div>
            <div class="col-md-12 d-flex justify-content-center" *ngIf="loadSeries">
              <div class="d-flex justify-content-center align-item-center cursor-pointer" (click)="loadSeriesData()" *ngIf="!isLoading ">
                <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" fill="currentColor" class="bi bi-arrow-repeat" viewBox="0 0 16 16">
                  <path d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41m-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9"/>
                  <path fill-rule="evenodd" d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5 5 0 0 0 8 3M3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9z"/>
                </svg>
              </div>
              <div *ngIf="isLoading" class="spinner-border spinner-border-lg fs-34" style="vertical-align:middle;" role="status">
              </div>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>
  <div class="row  ml-0 pl-0" [hidden]="!searchForm.value.search">
    <div class="col-lg-4 mb-2 col-4 text-center my-2 " *ngFor="let item of ['Live Tv','Movies','Series'] ; let i =index">
      <button class="search-menu btn px-lg-4 px-2  " [ngClass]="{'search-menu-borderTop': selectedMenuItem == item}"
        (click)="onMenuselect(item)">{{ getTranslation(i) | translate }}</button>
    </div>
    <div class="col-12" *ngIf="selectedMenuItem=='Live Tv'">
      <app-search-livetv [searchLiveTv]="searchForm.value.search" [liveStream]="liveStream"
        [liveCategoryList]="liveCategoryList" [isLoading]="isLiveLoading" #updateSearchLiveTv>
      </app-search-livetv>
    </div>
    <div class="col-12" *ngIf="selectedMenuItem=='Movies'">
      <app-search-movie [searchMovies]="searchForm.value.search" #updateSearchMovies></app-search-movie>
    </div>
    <div class="col-12" *ngIf="selectedMenuItem=='Series'">
      <app-search-series [searchSeriesTerm]="searchForm.value.search" [seriesShowList]="seriesShowList"
        #updateSearchSeries>
      </app-search-series>
    </div>
  </div>
</div>
